import { render, staticRenderFns } from "./DWT.vue?vue&type=template&id=6fc564af&scoped=true"
import script from "./DWT.vue?vue&type=script&lang=js"
export * from "./DWT.vue?vue&type=script&lang=js"
import style0 from "./DWT.vue?vue&type=style&index=0&id=6fc564af&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fc564af",
  null
  
)

export default component.exports